import { useEffect, useState } from "react";

export const ADMIN_AMBIENT_KEY = "admin-ambient";
export const ADMIN_AMBIENT_EVENT = "admin-ambient-change";

export function readAmbientPreference() {
  try {
    const saved = localStorage.getItem(ADMIN_AMBIENT_KEY);
    if (saved === "full" || saved === "reduced" || saved === "off") return saved;
  } catch {
    /* private mode */
  }
  return null;
}

function matches(query) {
  return window.matchMedia(query).matches;
}

export function resolveAmbient(preference) {
  if (matches("(prefers-reduced-transparency: reduce)")) return "off";
  if (preference === "off") return "off";
  if (matches("(prefers-reduced-motion: reduce)")) return "reduced";
  if (preference === "full" || preference === "reduced") return preference;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const phone = matches("(pointer: coarse)") || matches("(max-width: 1023px)");
  if (saveData || phone) return "reduced";
  return "full";
}

export function chooseAmbient(value) {
  try {
    localStorage.setItem(ADMIN_AMBIENT_KEY, value);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(ADMIN_AMBIENT_EVENT));
}

export default function useAdminAmbient() {
  const [preference, setPreference] = useState(readAmbientPreference);
  const [intensity, setIntensity] = useState(() => resolveAmbient(readAmbientPreference()));

  useEffect(() => {
    const update = () => {
      const next = readAmbientPreference();
      setPreference(next);
      setIntensity(resolveAmbient(next));
    };
    const queries = [
      "(prefers-reduced-motion: reduce)",
      "(prefers-reduced-transparency: reduce)",
      "(pointer: coarse)",
      "(max-width: 1023px)",
    ].map((query) => window.matchMedia(query));
    queries.forEach((mq) => mq.addEventListener("change", update));
    window.addEventListener(ADMIN_AMBIENT_EVENT, update);
    window.addEventListener("storage", update);
    return () => {
      queries.forEach((mq) => mq.removeEventListener("change", update));
      window.removeEventListener(ADMIN_AMBIENT_EVENT, update);
      window.removeEventListener("storage", update);
    };
  }, []);

  return { preference, intensity, choose: chooseAmbient };
}
